import React from 'react';
import LeadProvider from '../../providers/Lead';
import ListingPreviewBuyer from './ListingPreviewBuyer.router';

export default (props: any) => (
  <LeadProvider>
    <ListingPreviewBuyer {...props} />
  </LeadProvider>
);
